export const TEST_STR = {
  en: {
    back: "← Back to main site",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    rights: "© 2026 Pranjal Sir Physics",
    l_eyebrow: "FREE PHYSICS DIAGNOSTIC TEST",
    l_h1: "HOW STRONG IS YOUR PHYSICS PREPARATION?",
    l_sub: "Take the 10-Minute Physics Diagnostic Test and Discover Where You Are Losing Marks.",
    l_desc: "Answer just five Physics questions to evaluate your conceptual understanding, identify possible weaknesses, and receive personalized guidance from Pranjal Dwivedi Sir.",
    l_cta: "START MY FREE PHYSICS TEST",
    l_note: "Understand your mistakes. Improve your concepts. Build confidence in Physics.",
    l_notlive: "The test opens soon — register below and we’ll reach out.",
    l_features: [
      ["Only 5 Physics Questions", "No long papers — five focused MCQs."],
      ["Just 10 Minutes", "A quick, honest self-check of your concepts."],
      ["Instant Score & Analysis", "Question-wise mistakes, explained clearly."],
      ["Free One-to-One Consultation", "Personal guidance from Pranjal Dwivedi Sir."],
      ["Cashback Reward", "For eligible students scoring 4 or 5 correct."],
    ],
    l_mentor: "YOUR MENTOR",
    l_regtitle: "Tell us who’s taking the test",
    l_regsub: "Takes 30 seconds. Your details stay private and are used only for your test, consultation and reward.",
    l_step: "STEP 1 — REGISTER",
    l_name: "FULL NAME *",
    l_wa: "WHATSAPP NUMBER *",
    l_class: "CLASS *",
    l_exam: "TARGET EXAM *",
    l_email: "EMAIL (OPTIONAL)",
    l_school: "SCHOOL / COACHING (OPTIONAL)",
    l_ph_name: "Your full name",
    l_ph_phone: "10-digit number",
    l_sel_class: "Select class",
    l_sel_exam: "Select exam",
    l_classes: ["Class 11", "Class 12", "Dropper"],
    l_exams: ["NEET", "JEE Main", "JEE Advanced", "Other"],
    l_consent_a: "I have read the",
    l_consent_b: "and agree that Pranjal Sir Physics may store and process my details to conduct the diagnostic test, consultation and reward process. *",
    l_promo: "(Optional) Send me occasional updates, tips and offers on WhatsApp. Not required to take the test.",
    l_submit: "REGISTER & START THE TEST",
    l_submitting: "Registering…",
    l_err_phone: "Please enter a valid 10-digit Indian WhatsApp number.",
    l_err_consent: "Please accept the privacy notice to continue.",
    l_err_generic: "Something went wrong. Please try again.",
    e_honesty: "NO CHEATING — ATTEMPT HONESTLY!",
    e_qof: "QUESTION",
    e_of: "OF",
    e_qt: "Q TIME",
    e_answered_note: "answered · Answers save automatically",
    e_prev: "Previous",
    e_next: "Next",
    e_submit: "Submit Test",
    e_confirm_title: "Submit your test?",
    e_confirm_body: "Answers lock after submission and cannot be changed.",
    e_you_answered: "You have answered",
    e_yes: "Yes, submit",
    e_keep: "Keep answering",
    e_prep: "Preparing your test…",
    e_prep_ai: "Pranjal Sir is finding 5 fresh questions for you — this takes up to 30 seconds. Please don't close this page.",
    e_hold: "Hold on",
    e_back: "Back to registration",
    e_submitting: "Submitting…",
    e_submit_fail: "Could not submit. Check your connection and try again.",
    e_start_fail: "Could not start the test. Please try again.",
    e_answered_line: (n, total) => `${n} of ${total} answered · Answers save automatically`,
    e_submit_count: (n, total) => `SUBMIT TEST (${n}/${total} answered)`,
    e_confirm_answered: (n, total) => `You have answered ${n} of ${total} questions.`,
    r_eyebrow: "PHYSICS DIAGNOSTIC TEST — COMPLETE",
    r_congrats: "CONGRATULATIONS",
    r_done: "You have successfully completed your Physics Diagnostic Test.",
    r_correct: "CORRECT",
    r_incorrect: "INCORRECT",
    r_unans: "UNANSWERED",
    r_acc: "ACCURACY",
    r_time: "TIME TAKEN",
    r_reward_title: "CONGRATULATIONS! YOU HAVE UNLOCKED A CASHBACK REWARD!",
    r_reward_pre: "Your assigned reward is",
    r_reward_post: "Complete your FREE 1-to-1 Consultation and Physics Viva with Pranjal Dwivedi Sir to qualify for payment.",
    r_keep_title: "Keep Learning!",
    r_keep_body: "You can still book a FREE Physics Consultation with Pranjal Dwivedi Sir to understand your mistakes and improve your preparation.",
    r_waiting: "YOUR CASHBACK IS WAITING!",
    r_step1: "Step 1: Book your FREE 1-to-1 Consultation",
    r_step2: "Step 2: Attend your Consultation and Physics Viva with Pranjal Dwivedi Sir.",
    r_step3: "Step 3: Once both are completed and verified, your cashback will be reviewed for payment.",
    r_book: "BOOK MY FREE CONSULTATION & VIVA",
    r_book_free: "BOOK MY FREE CONSULTATION",
    r_analysis_title: "Question-wise Answer Analysis",
    r_analysis_sub: "See exactly where marks were gained or lost — with explanations.",
    r_your: "Your Answer:",
    r_correct_ans: "Correct Answer:",
    r_not_attempted: "Not attempted",
    r_expl: "Explanation:",
    r_sol: "Detailed solution:",
    r_status_link: "View my cashback status page →",
    r_loading: "Calculating your result…",
    r_load_err: "Could not load your result. Please check the link.",
    r_option: "Option",
    r_share: "Share my score on WhatsApp",
    r_share_text: (score, max, correct) => `I scored ${score}/${max} (${correct}/5 correct) on Pranjal Sir's Physics Challenge! Can you beat my score this week? Take the FREE 10-minute test: `,
    lb_title: "THIS WEEK'S TOPPERS",
    lb_sub: "Top 5 scores from the last 7 days. Take the test and claim your spot.",
    lb_empty: "No scores yet this week — be the first topper!",
    r_min: "min",
    r_track: ["Diagnostic Test", "Consultation", "Physics Viva", "Cashback Approved", "Cashback Paid"],
    pay_messages: {
      "Locked": "Locked — Complete your consultation and viva.",
      "Eligible for Review": "Eligible for Review — Your consultation and viva are complete. Your reward is awaiting review.",
      "Approved for Payment": "Approved for Payment — Your cashback has been approved.",
      "Payment Completed": "Payment Completed — Your cashback transfer has been confirmed.",
      "Payment Failed": "Payment Failed — Please contact support for assistance.",
    },
    st_correct: "CORRECT",
    st_incorrect: "INCORRECT",
    st_na: "NOT ATTEMPTED",
    b_eyebrow: "FREE 1-TO-1 CONSULTATION & VIVA",
    b_title: "Pick your slot",
    b_student: "STUDENT",
    b_sid: "STUDENT ID",
    b_wa: "WHATSAPP",
    b_exam: "TARGET EXAM",
    b_date: "PREFERRED DATE *",
    b_slots: "AVAILABLE TIME SLOTS *",
    b_noslots: "No slots available on this date — please pick another day.",
    b_diff: "MAIN PHYSICS DIFFICULTY *",
    b_diff_sel: "Select your biggest difficulty",
    b_diffs: ["Weak Concepts", "Numericals", "Doubt-Solving", "Exam Strategy", "Overall Improvement"],
    b_msg: "MESSAGE (OPTIONAL)",
    b_msg_ph: "Anything Pranjal Sir should know before the session…",
    b_upi: "UPI ID FOR CASHBACK (OPTIONAL — ONLY IF ELIGIBLE)",
    b_upi_ph: "yourname@upi — needed only when payment is due",
    b_upi_consent: "I consent to share my UPI ID with Pranjal Sir Physics for cashback payment. It is visible only to the administrator and never used for anything else. Never share your UPI PIN with anyone.",
    b_submit: "CONFIRM MY SLOT",
    b_submitting: "Booking…",
    b_confirmed: "YOUR CONSULTATION IS BOOKED!",
    b_ref: "BOOKING REFERENCE",
    b_date2: "DATE",
    b_time: "TIME",
    b_dur: "DURATION",
    b_dur_val: "minutes · Online 1-to-1 (Consultation + Viva)",
    b_note: "Our team will reach out on your WhatsApp number to confirm the appointment and share the meeting link.",
    b_gcal: "Add to Google Calendar",
    b_viewstatus: "View my status",
    s_eyebrow: "MY CASHBACK STATUS",
    s_title: "here’s where you stand",
    s_name: "STUDENT NAME",
    s_result: "DIAGNOSTIC RESULT",
    s_elig: "CASHBACK ELIGIBILITY",
    s_amount: "ASSIGNED CASHBACK",
    s_consult: "CONSULTATION STATUS",
    s_viva: "VIVA STATUS",
    s_pay: "PAYMENT STATUS",
    s_notyet: "Not attempted yet",
    s_eligible: "Eligible",
    s_noteligible: "Not Eligible",
    s_notbooked: "Not booked",
    s_completed: "Completed",
    s_pending: "Pending",
    s_booked: "Booked —",
    s_still: "You can still book a FREE consultation to understand your mistakes — it’s open to every student.",
    s_book: "BOOK MY FREE CONSULTATION & VIVA",
    s_book_free: "BOOK FREE CONSULTATION",
    s_cancel: "Cancel booking",
    s_cancelling: "Cancelling…",
    s_cancel_confirm: "Cancel this consultation booking?",
    s_loading: "Loading your status…",
    s_notfound: "Student not found. Check your Student ID.",
    s_greeting: (name) => `Hi ${name}, here’s where you stand`,
    s_cancel_err: "Could not cancel. Please contact the team on WhatsApp.",
    s_topics_title: "YOUR TOPIC RESULTS",
    s_topic: "TOPIC",
    tp_title: "CHOOSE YOUR PHYSICS TOPIC",
    tp_back_portal: "← Back to Student Portal",
    qs_title: "Quick start — no form, no password",
    qs_sub: "Sign in with Google or get a one-time code on your email. Taken the test before? Your past scores load automatically.",
    qs_google: "Continue with Google",
    qs_or: "or get a login code on email",
    qs_email_label: "YOUR EMAIL",
    qs_send: "EMAIL ME A CODE",
    qs_code: "6-DIGIT CODE",
    qs_verify: "VERIFY & START",
    qs_sent: "Code sent! Check your inbox (and spam folder).",
    qs_resend_wait: (s) => `Resend in ${s}s`,
    qs_resend: "Send a new code",
    qs_details_title: "Almost there — 3 quick details",
    qs_details_sub: "Needed just once for your cashback reward and consultation booking.",
    qs_start: "START MY TEST",
    qs_or_form: "or register with the full form below",
    tp_sub: "Select the Physics topic you want to practice. Test your concepts, discover your mistakes, and improve your preparation with Pranjal Sir.",
    tp_master: "CHOOSE WHAT YOU WANT TO MASTER",
    tp_q_count: (n) => `${n} question${n === 1 ? "" : "s"} available`,
    tp_select: "SELECT TOPIC",
    tp_unavailable: "Test not available yet for this topic — please choose another.",
    tp_needs: "needs 5+ questions to go live",
    tp_view_result: "VIEW RESULT",
    tp_resume: "RESUME TEST",
    tp_done: "Completed",
    tp_score_line: (score, max) => `Scored ${score}/${max}`,
    tp_none: "No topics published yet — please check back soon.",
    tp_loading: "Loading topics…",
    r_result_of: (topic) => `YOUR RESULT: ${topic.toUpperCase()}`,
    r_scored_in: (score, max, topic) => `You scored ${score}/${max} in the ${topic} Diagnostic Test.`,
    r_review_note: "Review your answers and identify the concepts that need improvement.",
    r_explore: "PRACTICE ANOTHER TOPIC",
  },
  hi: {
    back: "← मुख्य साइट पर वापस",
    privacy: "प्राइवेसी नीति",
    terms: "नियम व शर्तें",
    rights: "© 2026 Pranjal Sir Physics",
    l_eyebrow: "फ्री फिज़िक्स डायग्नोस्टिक टेस्ट",
    l_h1: "आपकी फिज़िक्स तैयारी कितनी मज़बूत है?",
    l_sub: "10-मिनट का फिज़िक्स डायग्नोस्टिक टेस्ट दें और जानें कहाँ नंबर कट रहे हैं।",
    l_desc: "सिर्फ पाँच फिज़िक्स सवालों से अपनी कॉन्सेप्ट समझ का आकलन करें, कमज़ोरियाँ पहचानें, और प्रांजल द्विवेदी सर से व्यक्तिगत मार्गदर्शन पाएँ।",
    l_cta: "मेरा फ्री फिज़िक्स टेस्ट शुरू करें",
    l_note: "अपनी गलतियाँ समझें। कॉन्सेप्ट सुधारें। फिज़िक्स में आत्मविश्वास बढ़ाएँ।",
    l_notlive: "टेस्ट जल्द खुलेगा — नीचे रजिस्टर करें, हम संपर्क करेंगे।",
    l_features: [
      ["सिर्फ 5 फिज़िक्स सवाल", "लंबा पेपर नहीं — पाँच केंद्रित MCQ।"],
      ["सिर्फ 10 मिनट", "आपके कॉन्सेप्ट की त्वरित, ईमानदार जाँच।"],
      ["तुरंत स्कोर और विश्लेषण", "हर सवाल की गलती, साफ व्याख्या के साथ।"],
      ["फ्री वन-टू-वन कंसल्टेशन", "प्रांजल द्विवेदी सर का व्यक्तिगत मार्गदर्शन।"],
      ["कैशबैक इनाम", "4 या 5 सही करने वाले योग्य विद्यार्थियों के लिए।"],
    ],
    l_mentor: "आपके मेंटर",
    l_regtitle: "बताएँ कौन टेस्ट दे रहा है",
    l_regsub: "सिर्फ 30 सेकंड। आपकी जानकारी निजी रहती है और केवल टेस्ट, कंसल्टेशन व इनाम के लिए उपयोग होती है।",
    l_step: "चरण 1 — रजिस्ट्रेशन",
    l_name: "पूरा नाम *",
    l_wa: "WHATSAPP नंबर *",
    l_class: "कक्षा *",
    l_exam: "लक्षित परीक्षा *",
    l_email: "ईमेल (वैकल्पिक)",
    l_school: "स्कूल / कोचिंग (वैकल्पिक)",
    l_ph_name: "आपका पूरा नाम",
    l_ph_phone: "10-अंकों का नंबर",
    l_sel_class: "कक्षा चुनें",
    l_sel_exam: "परीक्षा चुनें",
    l_classes: ["Class 11", "Class 12", "Dropper"],
    l_exams: ["NEET", "JEE Main", "JEE Advanced", "Other"],
    l_consent_a: "मैंने",
    l_consent_b: "पढ़ ली है और सहमत हूँ कि Pranjal Sir Physics टेस्ट, कंसल्टेशन और इनाम प्रक्रिया के लिए मेरी जानकारी सहेज व संसाधित कर सकती है। *",
    l_promo: "(वैकल्पिक) मुझे WhatsApp पर कभी-कभी अपडेट, टिप्स और ऑफर भेजें। टेस्ट के लिए यह ज़रूरी नहीं है।",
    l_submit: "रजिस्टर करें और टेस्ट शुरू करें",
    l_submitting: "रजिस्टर हो रहा है…",
    l_err_phone: "कृपया मान्य 10-अंकों का भारतीय WhatsApp नंबर डालें।",
    l_err_consent: "आगे बढ़ने के लिए कृपया प्राइवेसी नोटिस स्वीकार करें।",
    l_err_generic: "कुछ गड़बड़ हो गई। कृपया फिर प्रयास करें।",
    e_honesty: "नकल नहीं — ईमानदारी से हल करें!",
    e_qof: "सवाल",
    e_of: "में से",
    e_qt: "प्रश्न समय",
    e_answered_note: "हल किए · उत्तर अपने आप सेव होते हैं",
    e_prev: "पिछला",
    e_next: "अगला",
    e_submit: "टेस्ट सबमिट करें",
    e_confirm_title: "टेस्ट सबमिट करें?",
    e_confirm_body: "सबमिट के बाद उत्तर लॉक हो जाते हैं और बदले नहीं जा सकते।",
    e_you_answered: "आपने हल किए",
    e_yes: "हाँ, सबमिट करें",
    e_keep: "और हल करूँ",
    e_prep: "आपका टेस्ट तैयार हो रहा है…",
    e_prep_ai: "प्रांजल सर आपके लिए 5 नए प्रश्न ढूंढ रहे हैं — इसमें लगभग 30 सेकंड लगते हैं। कृपया यह पेज बंद न करें।",
    e_hold: "रुकिए",
    e_back: "रजिस्ट्रेशन पर वापस",
    e_submitting: "सबमिट हो रहा है…",
    e_submit_fail: "सबमिट नहीं हो पाया। कनेक्शन जाँचकर फिर प्रयास करें।",
    e_start_fail: "टेस्ट शुरू नहीं हो पाया। कृपया फिर प्रयास करें।",
    e_answered_line: (n, total) => `${total} में से ${n} हल किए · उत्तर अपने आप सेव होते हैं`,
    e_submit_count: (n, total) => `टेस्ट सबमिट करें (${n}/${total} हल किए)`,
    e_confirm_answered: (n, total) => `आपने ${total} में से ${n} सवाल हल किए हैं।`,
    r_eyebrow: "फिज़िक्स डायग्नोस्टिक टेस्ट — पूर्ण",
    r_congrats: "बधाई हो",
    r_done: "आपने अपना फिज़िक्स डायग्नोस्टिक टेस्ट सफलतापूर्वक पूरा किया।",
    r_correct: "सही",
    r_incorrect: "गलत",
    r_unans: "अनुत्तरित",
    r_acc: "सटीकता",
    r_time: "लिया गया समय",
    r_reward_title: "बधाई हो! आपने कैशबैक इनाम अनलॉक किया!",
    r_reward_pre: "आपका निर्धारित इनाम है",
    r_reward_post: "भुगतान की योग्यता के लिए प्रांजल द्विवेदी सर के साथ फ्री 1-to-1 कंसल्टेशन और फिज़िक्स वायवा पूरा करें।",
    r_keep_title: "सीखते रहें!",
    r_keep_body: "आप अभी भी प्रांजल द्विवेदी सर के साथ फ्री फिज़िक्स कंसल्टेशन बुक कर सकते हैं — अपनी गलतियाँ समझें और तैयारी सुधारें।",
    r_waiting: "आपका कैशबैक इंतज़ार में है!",
    r_step1: "चरण 1: अपनी फ्री 1-to-1 कंसल्टेशन बुक करें",
    r_step2: "चरण 2: प्रांजल द्विवेदी सर के साथ कंसल्टेशन और फिज़िक्स वायवा में शामिल हों।",
    r_step3: "चरण 3: दोनों पूरे व सत्यापित होने पर आपका कैशबैक भुगतान के लिए समीक्षा में जाएगा।",
    r_book: "मेरी फ्री कंसल्टेशन और वायवा बुक करें",
    r_book_free: "मेरी फ्री कंसल्टेशन बुक करें",
    r_analysis_title: "सवाल-दर-सवाल उत्तर विश्लेषण",
    r_analysis_sub: "देखें कहाँ नंबर मिले या कटे — व्याख्या सहित।",
    r_your: "आपका उत्तर:",
    r_correct_ans: "सही उत्तर:",
    r_not_attempted: "हल नहीं किया",
    r_expl: "व्याख्या:",
    r_sol: "विस्तृत हल:",
    r_status_link: "मेरा कैशबैक स्टेटस पेज देखें →",
    r_loading: "आपका परिणाम निकाला जा रहा है…",
    r_load_err: "परिणाम लोड नहीं हो पाया। कृपया लिंक जाँचें।",
    r_option: "विकल्प",
    r_share: "WhatsApp पर अपना स्कोर शेयर करें",
    r_share_text: (score, max, correct) => `मैंने Pranjal Sir के फिज़िक्स चैलेंज में ${score}/${max} स्कोर किया (${correct}/5 सही)! क्या आप इस हफ्ते मेरा स्कोर हरा सकते हैं? FREE 10-मिनट टेस्ट दें: `,
    lb_title: "इस हफ्ते के टॉपर्स",
    lb_sub: "पिछले 7 दिनों के टॉप-5 स्कोर। टेस्ट दें और अपनी जगह बनाएँ।",
    lb_empty: "इस हफ्ते अभी कोई स्कोर नहीं — पहले टॉपर बनें!",
    r_min: "मिनट",
    r_track: ["डायग्नोस्टिक टेस्ट", "कंसल्टेशन", "फिज़िक्स वायवा", "कैशबैक स्वीकृत", "कैशबैक भुगतान"],
    pay_messages: {
      "Locked": "लॉक्ड — अपनी कंसल्टेशन और वायवा पूरी करें।",
      "Eligible for Review": "समीक्षा हेतु योग्य — आपकी कंसल्टेशन और वायवा पूरी हो गई है। आपका इनाम समीक्षा की प्रतीक्षा में है।",
      "Approved for Payment": "भुगतान हेतु स्वीकृत — आपका कैशबैक स्वीकृत हो गया है।",
      "Payment Completed": "भुगतान पूर्ण — आपके कैशबैक ट्रांसफर की पुष्टि हो गई है।",
      "Payment Failed": "भुगतान विफल — कृपया सहायता के लिए संपर्क करें।",
    },
    st_correct: "सही",
    st_incorrect: "गलत",
    st_na: "हल नहीं किया",
    b_eyebrow: "फ्री 1-to-1 कंसल्टेशन और वायवा",
    b_title: "अपना स्लॉट चुनें",
    b_student: "विद्यार्थी",
    b_sid: "स्टूडेंट ID",
    b_wa: "WHATSAPP",
    b_exam: "लक्षित परीक्षा",
    b_date: "पसंदीदा तारीख *",
    b_slots: "उपलब्ध समय स्लॉट *",
    b_noslots: "इस तारीख को कोई स्लॉट उपलब्ध नहीं — कृपया दूसरा दिन चुनें।",
    b_diff: "मुख्य फिज़िक्स कठिनाई *",
    b_diff_sel: "अपनी सबसे बड़ी कठिनाई चुनें",
    b_diffs: ["Weak Concepts", "Numericals", "Doubt-Solving", "Exam Strategy", "Overall Improvement"],
    b_msg: "संदेश (वैकल्पिक)",
    b_msg_ph: "सेशन से पहले प्रांजल सर कुछ जान लें…",
    b_upi: "कैशबैक के लिए UPI ID (वैकल्पिक — केवल योग्य होने पर)",
    b_upi_ph: "yourname@upi — भुगतान के समय ही ज़रूरी",
    b_upi_consent: "मैं कैशबैक भुगतान के लिए Pranjal Sir Physics के साथ अपनी UPI ID साझा करने की सहमति देता/देती हूँ। यह केवल एडमिन को दिखती है। अपना UPI PIN किसी के साथ कभी साझा न करें।",
    b_submit: "मेरा स्लॉट पक्का करें",
    b_submitting: "बुक हो रहा है…",
    b_confirmed: "आपकी कंसल्टेशन बुक हो गई!",
    b_ref: "बुकिंग रेफरेंस",
    b_date2: "तारीख",
    b_time: "समय",
    b_dur: "अवधि",
    b_dur_val: "मिनट · ऑनलाइन 1-to-1 (कंसल्टेशन + वायवा)",
    b_note: "हमारी टीम अपॉइंटमेंट कन्फर्म करने और मीटिंग लिंक देने के लिए आपके WhatsApp नंबर पर संपर्क करेगी।",
    b_gcal: "Google Calendar में जोड़ें",
    b_viewstatus: "मेरा स्टेटस देखें",
    s_eyebrow: "मेरा कैशबैक स्टेटस",
    s_title: "यहाँ है आपकी स्थिति",
    s_name: "विद्यार्थी का नाम",
    s_result: "डायग्नोस्टिक परिणाम",
    s_elig: "कैशबैक योग्यता",
    s_amount: "निर्धारित कैशबैक",
    s_consult: "कंसल्टेशन स्थिति",
    s_viva: "वायवा स्थिति",
    s_pay: "भुगतान स्थिति",
    s_notyet: "अभी टेस्ट नहीं दिया",
    s_eligible: "योग्य",
    s_noteligible: "योग्य नहीं",
    s_notbooked: "बुक नहीं",
    s_completed: "पूर्ण",
    s_pending: "बाकी",
    s_booked: "बुक्ड —",
    s_still: "आप अभी भी अपनी गलतियाँ समझने के लिए फ्री कंसल्टेशन बुक कर सकते हैं — यह हर विद्यार्थी के लिए खुली है।",
    s_book: "मेरी फ्री कंसल्टेशन और वायवा बुक करें",
    s_book_free: "फ्री कंसल्टेशन बुक करें",
    s_cancel: "बुकिंग रद्द करें",
    s_cancelling: "रद्द हो रहा है…",
    s_cancel_confirm: "यह कंसल्टेशन बुकिंग रद्द करें?",
    s_loading: "आपका स्टेटस लोड हो रहा है…",
    s_notfound: "विद्यार्थी नहीं मिला। अपनी Student ID जाँचें।",
    s_greeting: (name) => `नमस्ते ${name}, यहाँ है आपकी स्थिति`,
    s_cancel_err: "रद्द नहीं हो पाया। कृपया WhatsApp पर टीम से संपर्क करें।",
    s_topics_title: "आपके टॉपिक परिणाम",
    s_topic: "टॉपिक",
    tp_title: "अपना फिज़िक्स टॉपिक चुनें",
    tp_back_portal: "← स्टूडेंट पोर्टल पर वापस जाएं",
    qs_title: "तुरंत शुरू करें — न फ़ॉर्म, न पासवर्ड",
    qs_sub: "Google से साइन इन करें या अपने ईमेल पर वन-टाइम कोड पाएं। पहले टेस्ट दे चुके हैं? आपके पिछले स्कोर अपने आप लोड हो जाएंगे।",
    qs_google: "Google से जारी रखें",
    qs_or: "या ईमेल पर लॉगिन कोड पाएं",
    qs_email_label: "आपका ईमेल",
    qs_send: "मुझे कोड ईमेल करें",
    qs_code: "6-अंकों का कोड",
    qs_verify: "वेरीफाई करें और शुरू करें",
    qs_sent: "कोड भेज दिया गया! अपना इनबॉक्स (और स्पैम फ़ोल्डर) देखें।",
    qs_resend_wait: (s) => `${s}s में दोबारा भेजें`,
    qs_resend: "नया कोड भेजें",
    qs_details_title: "बस एक कदम और — 3 छोटी जानकारियाँ",
    qs_details_sub: "आपके कैशबैक रिवॉर्ड और कंसल्टेशन बुकिंग के लिए बस एक बार चाहिए।",
    qs_start: "मेरी टेस्ट शुरू करें",
    qs_or_form: "या नीचे पूरा फ़ॉर्म भरकर रजिस्टर करें",
    tp_sub: "वह फिज़िक्स टॉपिक चुनें जिसे आप प्रैक्टिस करना चाहते हैं। अपने कॉन्सेप्ट परखें, अपनी गलतियाँ जानें, और प्रांजल सर के साथ अपनी तैयारी सुधारें।",
    tp_master: "चुनें कि आप क्या मास्टर करना चाहते हैं",
    tp_q_count: (n) => `${n} सवाल उपलब्ध`,
    tp_select: "टॉपिक चुनें",
    tp_unavailable: "इस टॉपिक का टेस्ट अभी उपलब्ध नहीं — कृपया दूसरा टॉपिक चुनें।",
    tp_needs: "लाइव होने के लिए 5+ सवाल चाहिए",
    tp_view_result: "परिणाम देखें",
    tp_resume: "टेस्ट जारी रखें",
    tp_done: "पूर्ण",
    tp_score_line: (score, max) => `स्कोर ${score}/${max}`,
    tp_none: "अभी कोई टॉपिक प्रकाशित नहीं — कृपया बाद में देखें।",
    tp_loading: "टॉपिक लोड हो रहे हैं…",
    r_result_of: (topic) => `आपका परिणाम: ${topic.toUpperCase()}`,
    r_scored_in: (score, max, topic) => `आपने ${topic} डायग्नोस्टिक टेस्ट में ${max} में से ${score} अंक पाए।`,
    r_review_note: "अपने उत्तर दोबारा देखें और पहचानें कि किन कॉन्सेप्ट को सुधारना है।",
    r_explore: "दूसरा टॉपिक प्रैक्टिस करें",
  },
};
